import React from 'react';
import BookingTrustStrip from './BookingTrustStrip';

const STEPS = [
	'Choose your journey and preferred dates',
	'See an estimated total based on CMS journey pricing',
	'Tell us group size, language, and any special requirements',
	'VisitAllNepal reviews and assigns the best operator',
	'You confirm and pay through VisitAllNepal only',
];

export default function PrivateTourInfoAside() {
	return (
		<div className="booking-aside">
			<h2>How private tours work</h2>
			<p className="booking-aside__lead">
				There is no catalog to browse. Submit one request and our team builds your itinerary,
				contacts verified operators internally, and follows up with a confirmed proposal.
			</p>
			<ol className="booking-aside__steps">
				{STEPS.map((step) => (
					<li key={step}>{step}</li>
				))}
			</ol>
			<BookingTrustStrip light />
		</div>
	);
}
